import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { FormsByCategory_Dashboard } from '../../entities/global/model';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { SafetyInductionService } from '../../services/safety-induction.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-incident-mti-dialod',
  templateUrl: './incident-mti-dialod.component.html',
  styleUrls: ['./incident-mti-dialod.component.scss']
})
export class IncidentMtiDialodComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<IncidentMtiDialodComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _inductionService: SafetyInductionService,
    private readonly _pref: PreferencesService,
    private _router: Router,
    ) { }


    Label2="Days since last MTI"
    NodataLabel2="There are no MTI Incidents for the State/s and Month currently selected"
    isnoData:boolean=false
    inputValueMonth=this.data.inputValueMonth
    stateID=this.data.stateID
    FormList:FormsByCategory_Dashboard[]=[]
  ngOnInit() {
    this.LoadLTIData();
  }

  LoadLTIData() {
    this._safetyGeneraldashboardService.GetLastMTIDashboard(this.inputValueMonth, this.stateID).subscribe(res => {
  console.log("LTI",res)
  
  this.FormList=res
  if(this.FormList.length<=0)
  {
   this.isnoData=true
  }
  
    })
  }

  onClickOpenForm(form) {
    if (form.IsDigitalForm) {
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
   //   window.open('/editdigitalformscomponent/' + form.Id, '_blank');
   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/editdigitalformscomponent', form.Id]);
    }else{             
      window.open('/editdigitalformscomponent/' + form.Id, '_blank');
     
    }
});

    } else {
      //this._router.navigate(['/uploadformedit', form.Id]);
     // window.open('/uploadformedit/' + form.Id, '_blank');

     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/uploadformedit', form.Id]);
      }else{             
        window.open('/uploadformedit/' + form.Id, '_blank');
       
      }
  });

    }
  }

  onClickDownloadForm(form) {
    this._inductionService.GetFormFileData(form.Id).subscribe(msg => {
      var newstring = msg.slice(1);
      console.log('length ', newstring.length - 1)

      let _newstring = newstring.substring(0, newstring.length - 1);

      console.log("newstringnewstringnewstring", _newstring)

      var arrBuffer = this.base64ToArrayBuffer(msg);

      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      //const linkSource = `data:application/pdf;base64,${msg}`;
      var link = document.createElement('a');
      //const fileName = "vct_illustration.pdf";

      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.pdf';
      link.click();
    })
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}
